import { RangeHorizon } from '@chart';
import { SparklineChart } from '@terminal/components/sparkline-chart/SparklineChart';
import { useTranslation } from 'react-i18next';

import styles from './InsightDrawerSparklineChart.module.scss';
import type { InsightDrawerSparklineChartProps } from './insightDrawerHeaderTypes';

export const InsightDrawerSparklineChart = ({
  data,
}: InsightDrawerSparklineChartProps) => {
  const { t } = useTranslation(['chart']);

  return (
    <div aria-hidden className={styles.root}>
      <SparklineChart
        data={data}
        height={28}
        horizon={RangeHorizon.ThreeMonths}
        width={132}
      />
      <span className={styles.label}>
        {t('chart:intervals.horizon_ThreeMonths')}
      </span>
    </div>
  );
};
